import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PipelinedetailsFacade } from 'libs/pipeline/src/lib/states/+pipelinedetails/pipelinedetails.facade';
import { PipelineGenericFacade } from 'libs/pipeline/src/lib/states/+pipeline-generic/pipeline-generic.facade';
import {
  PipelineEncroachmentDto,
  ActivityactionspersonDto,
  PipelineAssetLocationDto,
  PipelineDetailsDto,
  PlractivityactionhistoryDto,
  PlrstageactivityDto,
  StakeholderRepDto,
  PipelineLicenseRequestDto,
} from '@cradua/data';
import { from, Observable } from 'rxjs';
import { Guid } from 'guid-typescript';
import { MatDialog } from '@angular/material/dialog';
import { DocumentComponent } from '../document/document.component';
import { DocumentFacade } from 'libs/generic-document/src/lib/document-states/document.facade';
import { StakeholderResponseService } from '../../services/stakeholder-response.service';

@Component({
  selector: 'app-stakeholder-response',
  templateUrl: './stakeholder-response.component.html',
  styleUrls: ['./stakeholder-response.component.scss'],
})
export class StakeholderResponseComponent implements OnInit {
  responseForm: FormGroup;
  encroachments$: Observable<PipelineEncroachmentDto[]>;
  isLoadingActivityActions$: any;
  isLoadingPipelineDetails$: Observable<any>;
  isLoadingPipelineAssetsLocations$: any;
  plrstageactivity$: Observable<PlrstageactivityDto[]>;
  plractivityactionhistory$: Observable<PlractivityactionhistoryDto[]>;
  PipelineAssetLocations$: Observable<PipelineAssetLocationDto[]>;
  activityactionsperson$: Observable<ActivityactionspersonDto[]>;
  pipelineDetails$: Observable<PipelineDetailsDto[]>;
  stakeholderReps$: Observable<StakeholderRepDto[]>;
  pipelineLicences$: Observable<PipelineLicenseRequestDto[]>;
  pipelineRequests = [];
  pipelineDetails: any[];
  stakeholderRep: any;
  selectedActivity: any;
  stakeholder: any;
  stakeholder$: Observable<any>;
  counts: any;
  documentForm: FormGroup;
  files: any;
  activityResponseHistory = [];
  showResponseHistory = false;
  groupedRequests;
  UnResponded: any;
  constructor(
    private gatewayFacade: GatewayFacade,
    private fb: FormBuilder,
    private stakeholderResponseService: StakeholderResponseService,
    private dialog: MatDialog,
    private pipelineGenericFacade: PipelineGenericFacade,
    private pipelineFacade: PipelinedetailsFacade,
    private genericDocumentFacade: DocumentFacade
  ) {}
  taskactionForm: FormGroup;
  activityactionspersons: ActivityactionspersonDto[];
  MainpipelinDetails: PipelineDetailsDto[];
  PipelineAssetLocations: PipelineAssetLocationDto[];
  plrstageactivitys: PlrstageactivityDto[];
  plractivityactionhistorys: PlractivityactionhistoryDto[];
  VirtualArrays: any[];
  StaffId;
  PipelineActivityDetails = [];
  RemarksDetails = [];
  showclass = 'none';
  showpercent;
  showeditpage = false;
  showcompletdate = false;
  showstartdate = false;
  TotalList = [];
  showremark = false;
  VirtualListArray = [];
  pipelineId;
  SelectedVirtualListArray;
  showselectedobject = false;
  selectedPipelineRequest;
  // constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.checkUserRepStatus();

    this.responseForm = this.fb.group({
      id: [''],
      PipelineLicenseRequestId: [''],
      PipelineId: [''],
      StakeholderId: [''],
      StakeholderName: [''],
      StakeholderRepId: [''],
      StakeholderRepName: [''],
      PLActivityId: [''],
      Response: [''],
      // Version: [''],
      // CreatedAt: [''],
      // UpdatedAt: [''],
    });
    // let doc;
    this.documentForm = this.fb.group({
      DocumentTitle: [''],
      DocumentTypeCodeId: [''],
      DocumentTypeId: [''],
      SecurityId: [''],
      FileLocationId: [''],
      Remarks: [''],
      Url: [''],
      DocRefNo: [''],
      FileName: [''],
      FilePath: [''],
      FileType: [''],
      id: [''],
    });
    this.pipelineDetails$ = this.pipelineFacade.loadPipelinedetails;
    this.pipelineDetails$.subscribe((pipelines) =>
      console.log('Pipelines: ', pipelines)
    );

    // this.pipelineDetails$ = this.pipelineGenericFacade.loadGatewayWithoutId(
    //   'PipelineDetails'
    // );
    this.pipelineDetails$.subscribe((data) => {
      console.log('Data: ', data);
      this.pipelineDetails = data;
    });
    //  console.log("Activityee", this.PipelineActivityDetails );
    this.loadall();

    // this.getCounts();
    // this.getPipelineDeta();
  }
  allPendingRequest() {
    // this.pipelineLicences$.subscribe((pipelineLicenseReq) => {
    //   this.pipelineRequests = pipelineLicenseReq;
    //   this.counts.all = pipelineLicenseReq.length;
    // });
    this.pipelineRequests = [
      ...this.groupedRequests?.UnResponded,
      ...this.groupedRequests?.Responded,
    ];
  }
  filterPipelineRequest(criteria) {
    // console.log('Criteria: ', criteria);
    // this.stakeholderResponseService
    //   .filterPipelineRequest(criteria, this.stakeholderRep.id)
    //   .subscribe((pipelineReq) => {
    //     this.pipelineRequests = pipelineReq;
    //     console.clear();
    //     console.log('Filtered List: ', pipelineReq);
    //     this.getCounts(this.stakeholderRep.id);
    //   });
    this.pipelineRequests = this.groupedRequests ? this.groupedRequests[criteria] : [];
    console.log('Criteria: ', this.groupedRequests, criteria);
  }

  getCounts(stakeholderId) {
    if (stakeholderId) {
      // console.log('Getting counts: ', stakeholderId);
      this.stakeholderResponseService
        .getCount(stakeholderId)
        .subscribe((data) => {
          this.counts = data;
          // console.log('Counts: ', data);
        });
    }
  }
  selectPipeline(pipelineReq) {
    // console.log('Data: ', pipelineReq);
    this.selectedPipelineRequest = pipelineReq;
    this.responseForm.patchValue({
      PipelineId: pipelineReq.PipelineId,
      PipelineLicenseRequestId: pipelineReq.id,
      StakeholderId: this.stakeholderRep.PipelineLicenseStakeholderId,
      StakeholderName: this.stakeholder.PipelineLicenseStakeholderName,
      StakeholderRepId: this.stakeholderRep.id,
      StakeholderRepName: this.stakeholderRep.StakeholderRepName,
      PLActivityId: this.selectedActivity.id,
      id: Guid.create().toString(),
    });
    this.getCounts(this.stakeholderRep.id);
  }
  closeResponseForm() {
    this.selectedActivity = null;
  }
  selectActivity(activity, pipelineReq, event: Event) {
    console.clear();
    // console.log('SelectedActivity: ', activity);
    event.stopPropagation();
    this.selectedActivity = activity;
    this.selectPipeline(pipelineReq);
    // console.log('PipelineReq: ', this.selectedPipelineRequest);
    this.getCounts(this.stakeholderRep.id);
  }
  getGrouped() {
    this.stakeholderResponseService
      .getGrouped(this.stakeholderRep.id)
      .subscribe((requests) => {
        this.groupedRequests = requests;
        console.log('Grouped Requests: ', requests);
        this.pipelineRequests = [
          ...requests?.UnResponded,
          ...requests?.Responded,
        ];
      });
  }
  checkUserRepStatus() {
    const user = JSON.parse(localStorage.getItem('LoggedInUser')).user;
    console.log('User logged in: ', user.UserName);
    this.stakeholderReps$ = this.gatewayFacade.genericFilterGateway(
      'StakeholderRep',
      'StakeholderRepEmail',
      user.UserName
    );
    this.stakeholderReps$.subscribe((a) => {
      console.log('StakeholderRep: ', a);
      this.stakeholderRep = a[0];
      if (a[0]) {
        this.getCounts(a[0].id);
        this.getGrouped();
      }
      // Get the stakehodder using the stakeholderpipelinelicenseId
      if (this.stakeholderRep) {
        console.log('There is now a stakeholder rep!!');
        this.stakeholder$ = this.gatewayFacade.genericFilterGateway(
          'PipelineLicenseStakeholder',
          'id',
          this.stakeholderRep.PipelineLicenseStakeholderId
        );
        this.stakeholder$.subscribe((stakeholder) => {
          this.stakeholder = stakeholder[0];
          console.log('Stakeholder: ', stakeholder);
        });
      }
    });
  }
  loadall() {
    // this.pipelineLicences$ = this.gatewayFacade.genericFilterGateway(
    //   'PipelineLicenseRequest',
    //   'Status',
    //   'Pending'
    // );
    // this.pipelineLicences$.subscribe((licenses) => {
    //   console.log('LicenseRequest: ', licenses);
    //   this.pipelineRequests = licenses;
    // });
    this.isLoadingActivityActions$ = this.gatewayFacade.isLoadingGateway(
      'ActivityActionsPerson'
    );
    this.isLoadingPipelineDetails$ = this.gatewayFacade.isLoadingGateway(
      'PipelineDetails'
    );
    this.isLoadingPipelineAssetsLocations$ = this.gatewayFacade.isLoadingGateway(
      'PipelineAssetLocation'
    );
    this.plrstageactivity$ = this.gatewayFacade.loadGateway('PLRStageActivity');
    this.plrstageactivity$.subscribe((plractivities) => {
      this.plrstageactivitys = plractivities;
      console.log('PLRActivities: ', plractivities);
    });
    // this.plractivityactionhistory$ = this.gatewayFacade.loadGateway(
    //   'PLRActivityActionHistory'
    // );
    // this.plractivityactionhistory$.subscribe((plractivities) => {
    //   this.plractivityactionhistorys = plractivities;
    //   console.log('PLRActHist: ', plractivities);
    // });

    // this.PipelineAssetLocations$ = this.gatewayFacade.loadGateway(
    //   'PipelineAssetLocation'
    // );
    // this.PipelineAssetLocations$.subscribe((assetLocation) => {
    //   this.PipelineAssetLocations = assetLocation;
    //   console.log('Asset Location: ', assetLocation);
    // });
    // this.activityactionsperson$ = this.gatewayFacade
    //   .loadGateway('ActivityActionsPerson')
    //   .pipe(
    //     map((item: ActivityactionspersonDto[]) => {
    //       let newactivityperson = item.filter(
    //         (m) => m.StaffId == this.StaffId && m.Status == 'Pending'
    //       );

    //       return newactivityperson;
    //     })
    //   );
    // this.activityactionsperson$.subscribe((actionpersons) => {
    //   this.activityactionspersons = actionpersons;
    //   console.log('Action Persons: ', actionpersons);
    // });
    // this.isLoadingPipelineDetails$ = this.pipelineFacade.isLoadingPipelinedetails(
    //   'e'
    // );
    // this.pipelineDetails$ = this.pipelineFacade.loadRegister$;

    // this.pipelineFacade.clearPipelinedetails.subscribe((pipelines) =>
    //   console.log('Pipelines: ', pipelines)
    // );
  }
  saveResponse() {
    // console.log('Form data: ', this.responseForm.value);
    // this.isLoadingPipelineDetails$ = this.gatewayFacade.isLoadingGateway();

    // save document
    this.uploadFiles();
    this.gatewayFacade.add('StakeholderResponse', [this.responseForm.value]);
    this.responseForm.reset();
    this.selectedPipelineRequest = null;
    this.selectedActivity = null;
    setTimeout(() => {
      this.getGrouped();
      this.getCounts(this.stakeholderRep.id);
    }, 3000);
  }

  getPipelineName(id) {
    // console.log('PipelineId: ', id);
    const pipelineReq = this.pipelineDetails.find((a) => a.id == id);
    return pipelineReq ? pipelineReq.PipelineName : '';
  }
  getPipelineReqActivities(pipelineReqId, templateId?) {
    // console.log('and', pipelineReqId);
    const plS = this.plrstageactivitys.filter(
      (a) => a.PipelineLicenceRequestId == pipelineReqId
    );
    // console.log('PipelineReqActivities: ', plS);
    return plS;
  }

  pickFiles(event?) {
    // this.files = event.target.files;
    // console.log('Files@ : ', this.files);
    console.log('Response@ : ', event);
    this.dialog.open(DocumentComponent, {
      data: event ? event : this.responseForm.value.id,
      width: '100%',
      height: '100%',
      hasBackdrop: true,
    });
  }

  uploadFiles() {
    if (this.files?.length) {
      for (const e of this.files) {
        console.log('E: ', e);
        const docs = {
          DocumentTitle: e.name.split('.')[0],
          DocumentTypeCodeId: '',
          DocumentTypeId: '',
          SecurityId: '',
          FileLocationId: '',
          Remarks: '',
          Url: '',
          DocRefNo: '',
          FileName: e.name,
          FilePath: e,
          FileType: e.type,
          id: Guid.create().toString(),
          LandTitleCode: this.responseForm.value.id,
          SecurityClassificationName: 'UNRESTRICTED',
          ApprovalStatus: 'NOT APPROVED',
        };

        const { FilePath, ...doc } = docs;
        if (typeof FilePath === 'string') {
          doc['FilePath'] = FilePath;
        }
        doc['type'] = 'landTitleRegister';
        const savedDoc = this.genericDocumentFacade.uploadSingleDocumentWithFile(
          doc,
          FilePath
        );

        //   reader.onload = () => {
        //     console.log('File: ', reader.result);
        //   };
        //   reader.readAsDataURL(e);
      }
    }
  }

  getResponseHistory(pIndex, aIndex) {
    console.clear();
    console.log('PIndex: ', pIndex, ' AIndex: ', aIndex);
    this.activityResponseHistory = this.pipelineRequests[pIndex].Activities[
      aIndex
    ].Responses;
    this.showResponseHistory = true;
    // this.stakeholderResponseService
    //   .getActivityResponseHistory(activityId)
    //   .subscribe((resHist) => {
    //     this.activityResponseHistory = resHist;
    //     console.log('Responses: ', resHist);
    //     this.showResponseHistory = true;
    //   });
  }
  getLastResponse(activityId) {
    this.activityResponseHistory = [];
    // const responses = this.gatewayFacade.genericFilterGateway('StakeholderResponse', 'ActivityId', activityId);
    // responses.subscribe(resHist =>{
    //   this.activityResponseHistory = resHist;
    // });
    let activityResponse;
    this.stakeholderResponseService
      .getLastActivityResponse(activityId)
      .subscribe((res) => {
        activityResponse = res;
        console.log('Last Response: ', res);
      });
    return activityResponse ? activityResponse : '';
  }
}
